import React, { useState } from "react";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import _ from "lodash";
import styles from "./customPagination.module.scss";
import { Box } from "@mui/material";
import i18next from "i18next";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import PropTypes from "prop-types";

const CustomPagination = (props) => {
  const {
    paginationResult,
    showRowPerPage = false,
    rowsPerPageOptions = [5, 10, 15],
    setCurrentPageNumber,
  } = props;

  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const pageNumber = _.get(paginationResult, "pageNumber", 1);
  const totalNoOfRecord = _.get(paginationResult, "totalRecords", 0);
  const pageSize = _.get(paginationResult, "pageSize", 1);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleRowChange = (event) => {
    setRowsPerPage(event.target?.value);
  };
  const handlePageChange = (event, value) => {
    setCurrentPageNumber(value);
  };

  return (
    <Box data-testid="pagination-test" className={styles.paginationWrapper}>
      <Box className={styles.fullwidthRow}>
        {showRowPerPage ? (
          <Box className={styles.showRowPerPage}>
            {i18next.t("Rijen per pagina:")}
            <Select
              labelId="pagination-row-per-page-select-label"
              id="pagination-row-per-page-select"
              open={open}
              onClose={handleClose}
              onOpen={handleOpen}
              value={rowsPerPage}
              onChange={handleRowChange}
              IconComponent={KeyboardArrowDownOutlinedIcon}
              data-testid="selectform"
            >
              {rowsPerPageOptions.map((pageNo, index) => {
                return (
                  <MenuItem value={pageNo} key={pageNo}>
                    {pageNo}
                  </MenuItem>
                );
              })}
            </Select>
          </Box>
        ) : null}
        <Box>
          <Stack spacing={2}>
            <Pagination
              count={Math.ceil(totalNoOfRecord / pageSize) || 0} // Error expected Integer recevied NAN
              page={Number(pageNumber)} // Error expected Integer recevied string
              onChange={handlePageChange}
              variant="outlined"
              shape="rounded"
              colSpan={3}
              rowsperpage={rowsPerPage}
            />
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

export default CustomPagination;
CustomPagination.propTypes = {
  paginationResult: PropTypes.any,
  showRowPerPage: PropTypes.any,
  rowsPerPageOptions: PropTypes.any,
  setCurrentPageNumber: PropTypes.any,
};
